const ErrorCode = {
    'EXPIRED': 440,
    'TERMINATED': 441
};

export default ErrorCode;